/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';

export default class AchievementHeader extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const { achievement, showDesc, actions } = this.attrs;

		if (!achievement) {
			return null;
		}

		return (
			<div className="AchievementHeader">
				<div className="AchievementHeader-name">{achievement.name()}</div>
				{actions && <div className="AchievementHeader-actions">{actions}</div>}
				{showDesc && <div className="AchievementHeader-description">{achievement.description()}</div>}
			</div>
		);
	}
}
